import React from 'react';
import { Box, FormHelperText, Typography } from '@mui/material';
import type { GameFormErrors } from '../../../../types/features/games';
import { adminColors, adminTypography } from '../../../../styles/adminDesignTokens';

interface GameDialogLocationFieldsProps {
  countryDisplayLabel: string;
  errors: GameFormErrors;
  stateDisplayLabel: string;
}

const GameDialogLocationFields: React.FC<GameDialogLocationFieldsProps> = ({
  countryDisplayLabel,
  errors,
  stateDisplayLabel,
}) => (
  <Box sx={{ borderBottom: `1px solid ${adminColors.divider}`, pb: 1 }}>
    <Typography component="h3" sx={{ ...adminTypography.cardTitle, color: adminColors.text }}>
      {stateDisplayLabel}, {countryDisplayLabel}
    </Typography>
    {(errors.country_code || errors.state_code) && (
      <FormHelperText error sx={{ mx: 0 }}>
        {errors.country_code || errors.state_code}
      </FormHelperText>
    )}
  </Box>
);

export default React.memo(GameDialogLocationFields);
